"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../Types");
var Validation = /** @class */ (function () {
    function Validation(Error, State) {
        var _this = this;
        if (Error === void 0) { Error = ""; }
        if (State === void 0) { State = Types_1.InputValidationState.unset; }
        this.isValid = function () {
            return _this.State === Types_1.InputValidationState.valid;
        };
        this.isInvalid = function () {
            return _this.State === Types_1.InputValidationState.invalid;
        };
        this.Error = Error;
        this.State = State;
    }
    Validation.prototype.reset = function () {
        this.Error = "";
        this.State = Types_1.InputValidationState.unset;
        return this;
    };
    return Validation;
}());
exports.Validation = Validation;
//# sourceMappingURL=Validation.js.map